import React from 'react';
import {Link} from 'react-router';

var defaultImg = require("../default.json");

var ListViewTransferRevoke = React.createClass({
	handleCloneClick: function(accountSlug, slug){
		this.props.clone("open", accountSlug, slug);
	},
	handleBrowseClick: function(accountSlug, slug){
		this.props.editTheme(slug, accountSlug, this.props.type);
	},
	render: function(){
		if(this.props.themes != undefined){
        	var themes = this.props.themes.map(function(value,index){
        		var accountSlug = value["name"].split("/")[0];
          		var slug = value["name"].split("/")[1];
        		var img = "";
		  		if(!(value["grid_layout_image"]) || value["grid_layout_image"] == "null"){
		  			img = <img src={defaultImg.DEFAULT_IMAGE} alt="" title="" className="img-responsive" local/> ;
		  		}
		  		else{
		  			img = <img src={value["grid_layout_image"]} alt="" title="" className="img-responsive"/>;
		  		}

		  		 /* rating star logic */
		        var ratings = [];
		        var ratingAvg  = value["rating_avg"];
		        for(var i=1;i<=5;i++)
		        {
		          var decimal = Math.floor(ratingAvg);
		          var fraction = ratingAvg % 1;
		          var ratingClas;
		          if(i<= decimal){
		            ratingClas = "fa fa-star";  // for empty star.
		          }
		          else if(fraction >= 0.5 && i<= decimal+1){
		            ratingClas = "fa fa-star-half-o";  // for half filled star.
		          }
		          else{
		            ratingClas = "fa fa-star-o";  // for full filled star.
		          }
		          ratings.push(<i key = {i} className = {ratingClas}/>);
		        }  
		return (
			<article className="theme-list clearfix" key = {index}>
              <div className="whole">
                <div className="theme-list__first-col">
                  <div className="theme-list__img"> <img src="images/theme_list--img.png" alt="" title="" className="img-responsive" /> </div>
                </div>
                <div className="theme-list__third-col">
                  <div className="theme-list__buttons">
                    {/*<button className="btn__lg bg-white"><i className="fa fa-eye"></i> Preview</button>*/}
                    <Link to={{ pathname: '/details', query: {val:  value["slug"]  ,account: value["user"], lib: this.props.libName} }} className="btn__lg bg-very_light"><i className="fa fa-mail-forward"></i> Details</Link>
			        <button className="btn__lg bg-dark" onClick = {this.handleBrowseClick.bind(this, accountSlug, slug, value["type"])}><i className="fa fa-search"></i> Browse</button>
                  </div>
                </div>
                <div className="theme-list__second-col clearfix">
                  <div className="theme-list__desc">
                    <div className="theme-list__desc--inner">
                      <h4>{slug}</h4>
			          <p>by {accountSlug}</p>
                      <p><strong><span>Rating:<span className="rating--star">{ratings}</span>({value["rating_count"]})</span></strong></p>
                    </div>
                     <button className="btn__lg bg-bold">Revoke</button>
                  </div>
                  <div className="theme-list__details theme-list__details--hide">
                    <ul className="badges__list list-inline">
                      {/*<li className="badges__list--item"><img src="images/badge_icon-001.png" alt="badges" title="badges" /></li>
                      <li className="badges__list--item"><img src="images/badge_icon-002.png" alt="badges" title="badges" /></li>
                      <li className="badges__list--item"><img src="images/badge_icon-003.png" alt="badges" title="badges" /></li>
                      <li className="badges__list--item"><img src="images/badge_icon-004.png" alt="badges" title="badges" /></li>
                      <li className="badges__list--item"><img src="images/badge_icon-005.png" alt="badges" title="badges" /></li>*/}
                    </ul>
                    <p><strong>Last Modified: 5/25/16</strong></p>
			        <p>{value["description"]}<span><Link to = {{ pathname: '/details', query: {val:  value["name"].split("/")[1]  ,account: value["name"].split("/")[1], lib: this.props.libName} }}>Read more..</Link></span></p>
                  </div>
                </div>
              </div>
            </article>
			);
		  	}, this);
        }
		return (
			<div>
				<div className="whole">
	            	<h4 className="filter--title">My Transfers to Other Accounts</h4>
	          	</div>
	          	<div className="theme-container clearfix list--container">
	          		{themes}
	          	</div>
          	</div>
		);
	}
});
export {ListViewTransferRevoke};


/** WEBPACK FOOTER **
 ** ./html/components/ListViewTransferRevoke.jsx
 **/